<!-- 类table的列表图 -->
<style lang="less" scoped>
.main {
  width: 100%;
  height: 100%;
  .list-item1 {
    color: #00fefb;
    height: 4vh;
    font-size: 1.6vh;
    display: flex;
    width: 92%;
    margin: 0 auto;
    background: rgba(33, 85, 255, 0.3);
    background-size: 100% 100%;
    .item1 {
      width: 40%;
      line-height: 4vh;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      text-align: center;
    }

    .item2 {
      width: 20%;
      line-height: 4vh;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      text-align: center;
    }
  }
  .swiper-wrap {
    margin-top: 0.25vh;
    height: 13.5vh;
    width: 92%;
    .list-item {
      background: #0b2574;
      height: 4vh;
      line-height: 4vh;
      display: flex;
      font-size: 1.4vh;
      margin-bottom: 0.5vh;
      color: #989cb0;
      .item1 {
        width: 40%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: center;
      }
      .item2 {
        width: 20%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: center;
      }
      .white {
        color: #fff;
      }
    }
  }
}
</style>

<template>
  <boxWrap :name="name" :min="min">
    <div class="main">
      <div class="list-item1">
        <div class="item1">时间</div>
        <div class="item2">基地</div>
        <div class="item2">批次名称</div>
        <div class="item2">记录节点</div>
      </div>
      <swiper
        :options="swiperOption"
        class="swiper-wrap"
        ref="mySwiper"
        v-if="tableData.length != 0"
      >
        <swiper-slide
          v-for="(item, index) in tableData"
          :key="index"
          class="list-item"
        >
          <div class="item1">{{ item.time }}</div>
          <div class="item2">{{ item.base }}</div>
          <div class="item2">{{ item.id }}</div>
          <div class="item2 white">{{ item.node }}</div>
        </swiper-slide>
      </swiper>
    </div>
    <!-- </div> -->
  </boxWrap>
</template>

<script>
import boxWrap from "../common/boxWrap";
// import '/../../../../static/css/swiper.css'
import "@/assets/css/swiper.css";

import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  props: ["salesDataRealTime"],
  data() {
    return {
      name: "溯源记录",
      tableData: [],
      time: null,
      min: "box-wrap3",
      swiperOption: {
        slidesPerView: "auto",
        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        notNextTick: true,
        // 循环
        loop: true,
        // 设定初始化时slide的索引
        initialSlide: 0,
        roundLengths: true,
        height: 100,
        // 自动播放
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          /* 触摸滑动后是否继续轮播 */
          disableOnInteraction: false
        },
        // autoplay: false,
        // 滑动速度
        speed: 800,
        // 滑动方向
        direction: "vertical",
        // 小手掌抓取滑动
        grabCursor: true
      },
      colorList: ["#f1641e", "#f1c21e", "#69ba32", "#0092ee"]
    };
  },
  methods: {
    changeColor(index) {
      if (index <= 3) {
        return `color:${this.colorList[index]}`;
      } else {
        return `color:${this.colorList[3]}`;
      }
    }
  },
  components: {
    boxWrap,
    swiper,
    swiperSlide
  },
  mounted() {
    this.tableData = [
      {
        time: "2019/10/19 09:21:31",
        base: "杭州余杭莲花种植基地",
        id: "1910548",
        node: "灌溉"
      },
      {
        time: "2019/09/14 08:01:12",
        base: "杭州梅家坞龙井种植基地/",
        id: "1907119",
        node: "修剪"
      },
      {
        time: "2019/08/11 14:51:11 ",
        base: "温州乐清铁皮石斛种植基地",
        id: "190322",
        node: "施肥"
      },
      {
        time: "2019/09/04 08:18:22",
        base: "湖州安吉白茶种植基地",
        id: "1902004",
        node: "植保"
      },
      {
        time: "2019/08/22 16:44:30",
        base: "温州马站四季柚种植基地",
        id: "1903182",
        node: "灌溉"
      }
    ];
  },
  beforeDestroy() {
    clearInterval(this.time);
    this.time = null;
  }
};
</script>



// WEBPACK FOOTER //
// index.vue?56083adc